<template>
    <div class="economy-learning-claims">
        <div class="placeholder">
            <div class="placeholder__heading">
                Hvad kan give effekt <u>direkte</u> på bundlinjen?
            </div>

            <div class="placeholder padding" v-if="data && !loading">
                <div class="intro">
                    Hvordan vil din bundlinje se ud, hvis du kan opnå...
                </div>
                <div class="row">
                    <div class="col-lg-3">
                        <div class="box">
                            <div class="heading">
                                Flere timer hos kunderne
                                <div class="small">
                                    I dag: {{ customerHours.now }} %
                                </div>
                            </div>
                            <div class="slider" v-if="customerHours.now > 0">
                                <input type="range" :min="customerHours.min" :max="customerHours.max" v-model="customerHours.value" />
                                <br>
                                <label>
                                    +
                                    {{ customerHours.value }}
                                    {{ customerHours.label }}
                                </label>
                            </div>
                            <div class="result" v-if="customerHours.now > 0">
                                <span v-if="customerHours.value != customerHours.min">
                                    + {{ customerHoursTotal | currency }}
                                </span>
                                <span v-else>
                                    -
                                </span>
                            </div>
                            <div v-else class="small">
                                Timer hos kunderne kan ikke udregnes. Tjek, at du har angivet hvilke medarbejdere, der skal tages med i denne udregning.
                            </div>
                            <div class="small" v-if="customerHours.value != customerHours.min">
                                Udregningen svarer til, at svendene i gennemsnit bruger <b>{{ Number(customerHours.now) + Number(customerHours.value) }}%</b> af deres tid hos kunderne
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="box">
                            <div class="heading">
                                Meromsætning pr. opgave
                                <div class="small">
                                    I dag: {{ data.revenue.avg_per_project | currency }} pr. opgave
                                </div>
                            </div>
                            <div class="slider">
                                <input type="range" :min="projectRevenue.min" :max="projectRevenue.max" v-model="projectRevenue.value" />
                                <br>
                                <label>
                                    +
                                    {{ projectRevenue.value }}
                                    {{ projectRevenue.label }}
                                </label>
                            </div>
                            <div class="result">
                                <span v-if="projectRevenue.value != projectRevenue.min">
                                    + {{ projectRevenueTotal | currency }}
                                </span>
                                <span v-else>
                                    -
                                </span>
                            </div>
                            <div class="small" v-if="projectRevenue.value != projectRevenue.min">
                                Udregningen svarer til, at den gennemsnitlige pris pr. opgave øges med <b>{{ projectRevenueTotal / data.revenue.total_projects | currency }}</b>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="box">
                            <div class="heading">
                                Besparelse på vareforbrug
                                <div class="small">
                                    I dag: {{ data.materials.total / data.revenue.total_projects | currency }} pr. opgave
                                </div>
                            </div>
                            <div class="slider">
                                <input type="range" :min="materialsUsage.min" :max="materialsUsage.max" v-model="materialsUsage.value" />
                                <br>
                                <label>
                                    {{ materialsUsage.value }}
                                    {{ materialsUsage.label }}
                                </label>
                            </div>
                            <div class="result">
                                <span v-if="materialsUsage.value != materialsUsage.min">
                                    + {{ materialsUsageTotal | currency }}
                                </span>
                                <span v-else>
                                    -
                                </span>
                            </div>
                            <div class="small" v-if="materialsUsage.value != materialsUsage.min">
                                Udregningen svarer til, at den gennemsnitlige udgift til vareforbrug pr. opgave skal nedjusteres med <b>{{ materialsUsageTotal / data.revenue.total_projects | currency }}</b>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <div class="box">
                            <div class="heading">
                                En forøgelse af mindste DG
                                <div class="small">
                                    Gns. DG pr. opgave i dag: {{ data.coverage.average_percent | coveragePercent }}%
                                </div>
                            </div>
                            <div class="slider">
                                <input type="range" :min="coveragePercent.min" :max="coveragePercent.max" v-model="coveragePercent.value" />
                                <br>
                                <label>
                                    {{ coveragePercent.value }}
                                    {{ coveragePercent.label }}
                                </label>
                            </div>
                            <div class="result">
                                <span v-if="coveragePercent.value != coveragePercent.min">
                                    + {{ coveragePercentTotal | currency }}
                                </span>
                                <span v-else>
                                    -
                                </span>
                            </div>
                            <div class="small" v-if="coveragePercent.value != coveragePercent.min">
                                Udregningen viser hvad du kan opnå, hvis du kan forbedre DG på alle opgaver til minimum <b>{{ coveragePercent.value }}%</b>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div class="break" />
                <div class="overview">
                    <div class="blank" />
                    <div class="today">
                        EBITDA i dag
                        <div class="value">
                            {{ ebitda | currency }}
                        </div>
                    </div>
                    <div class="arrow">
                        <i class="far fa-arrow-right" />
                    </div>
                    <div class="potential">
                        Potentielt fremtidigt EBITDA
                        <div class="value" v-if="totalPotential != ebitda">
                            {{ totalPotential | currency }}
                        </div>
                        <div class="value" v-else>
                            -
                        </div>
                    </div>
                    <div class="blank" />
                </div>
                <!--<div class="percentage" v-if="totalPotential != ebitda">
                    Du vil kunne vækste din virksomheds bundresultat med <b>{{ ((totalPotential / ebitda) * 100) - 100 | rounded }}%</b> ved at implementere ovenstående ændringer med din nuværende organisation.
                </div>-->
                
            </div>

            <box-loading height="350" v-else />

        </div>
        <!--<br><br>
        <li>Skal hentes fra eget API og ikke e-conomic, da vi skal kunne hente data kun for en given periode.</li>
        <li>Vi kan lave alle udregninger hvis blot vi har de overordnede tal for perioden: oms, DB, DG, fordeling af omkostninger mv.</li>
        <li>Hvis timer hos kunderne øges: Vi har opnået nuværende DB ved at arbejde fx 50% hos kunderne. Hvor meget mere vil vores dækningsbidrag være hvis vi arbejdede fx 60% hos kunderne?</li>
        <li>Hvis omsætning pr opgave øges: Hvis omsætningen øges med X antal %, hvad er så den direkte effekt på det samlede dækningsbidrag? Hvad bliver det øget med? Fx, ved 10% mere pr. opgave, tjener du 200.000kr direkte</li>
        <li>Hvis DG øges på opgaver: Hvis DG løftes på opgaver under X DG til Y DG, hvor meget bliver dit DB så bedre?</li>
        <li>Hvis der kan spares på vareforbrug: Hvis der kan spares X % på vareforbrug, hvor meget bedre bliver dit DB så?</li>
        <li>Boks: EBITDA i dag + alle 4 resultater = Hvordan din EBITDA <u>kunne</u> se ud. Vises som tabel med mellemregninger, der opdaterer live. Skal være = Potentiel øget EBITDA med eksisterende organisation (nuværende medarbejdere mv.)</li>-->
    </div>
</template>

<style lang="scss" scoped>
@import "../../../styles/vars.scss";

    .intro {
        font-size: $fontsize--main * 1.2;
        margin-bottom: $margin--main;
        text-align: center;
    }

    .box {
        text-align: center;
        font-family: $fontfamily--main;
        line-height: 1.5;

        .heading {
            font-weight: 600;

            .small {
                font-weight: normal;
                margin-top: 0;
            }
        }

        .slider {
            margin: $margin--small 0;

            input {
                max-width: 75%;
            }
        }

        .result {
            font-size: $fontsize--large;
            font-weight: bold;
            color: $color--green;
        }

        .small {
            font-size: $fontsize--small;
            margin-top: $margin--small;
        }
    }

    .overview {
        display: flex;
        align-items: center;
        justify-content: space-around;

        .today, .potential {
            font-size: $fontsize--main;
            text-align: center;

            .value {
                font-size: $fontsize--xl;
                font-weight: $fontweight--bold;
            }
        }

        .arrow {
            font-size: $fontsize--xl;
        }

        .potential {

            .value {
                color: $color--green;
            }
        }
    }

    .percentage {
        margin-top: $margin--main;
        text-align: center;
    }

</style>

<style lang="scss">
@import "../../../styles/vars.scss";

    input[type=range] {
        -webkit-appearance: none;
        margin: 18px 0;
        width: 100%;
    }
    input[type=range]:focus {
        outline: none;
    }
    input[type=range]::-webkit-slider-runnable-track {
        width: 100%;
        height: 8.4px;
        cursor: pointer;
        animate: 0.2s;
        // box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
        box-shadow: $boxshadow--creative;
        // background: #3071a9;
        // border-radius: 1.3px;
        border-radius: 1000px;
        border: 0.2px solid #010101;
        background: $color--dark;
    }
    input[type=range]::-webkit-slider-thumb {
        // box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
        box-shadow: $boxshadow--creative;
        // border: 1px solid #000000;
        border: 1px solid rgba(0, 0, 0, 0.3);
        height: 20px;
        width: 20px;
        border-radius: 3px;
        background: #ffffff;
        cursor: pointer;
        -webkit-appearance: none;
        margin-top: -6px;
        border-radius: 1000px;
    }
    input[type=range]:focus::-webkit-slider-runnable-track {
        // background: #367ebd;
        background: $color--dark;
    }
    input[type=range]::-moz-range-track {
        width: 100%;
        height: 8.4px;
        cursor: pointer;
        animate: 0.2s;
        box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
        // background: #3071a9;
        background: $color--dark;
        border-radius: 1.3px;
        border: 0.2px solid #010101;
    }
    input[type=range]::-moz-range-thumb {
        box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
        border: 1px solid #000000;
        height: 36px;
        width: 16px;
        border-radius: 3px;
        background: #ffffff;
        cursor: pointer;
    }
    input[type=range]::-ms-track {
        width: 100%;
        height: 8.4px;
        cursor: pointer;
        animate: 0.2s;
        background: transparent;
        border-color: transparent;
        border-width: 16px 0;
        color: transparent;
    }
    input[type=range]::-ms-fill-lower {
        // background: #2a6495;
        background: $color--dark;
        border: 0.2px solid #010101;
        border-radius: 2.6px;
        box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    }
    input[type=range]::-ms-fill-upper {
        // background: #3071a9;
        background: $color--dark;
        border: 0.2px solid #010101;
        border-radius: 2.6px;
        box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
    }
    input[type=range]::-ms-thumb {
        box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
        border: 1px solid #000000;
        height: 36px;
        width: 16px;
        border-radius: 3px;
        background: #ffffff;
        cursor: pointer;
    }
    input[type=range]:focus::-ms-fill-lower {
        // background: #3071a9;
        background: $color--dark;
    }
    input[type=range]:focus::-ms-fill-upper {
        // background: #367ebd;
        background: $color--dark;
    }

</style>

<script>
import * as economyService from '@/services/economyService'

export default {
    data () {
        return {
            loading: true,
            data: null,
            ebitda: null,
            customerHours: {
                now: 46,
                min: 0,
                max: 54,
                value: 0,
                label: '%'
            },
            projectRevenue: {
                now: 12300,
                min: 0,
                max: 100,
                value: 0,
                label: '%'
            },
            materialsUsage: {
                now: 2400,
                min: 0,
                max: 100,
                value: 0,
                label: '%'
            },
            coveragePercent: {
                now: 45,
                min: 0,
                max: 100,
                value: 0,
                label: '%'
            }
        }
    },
    created () {
        this.getData()
    },
    methods: {
        getData () {
            this.loading = true
            let params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            }
            economyService.keyFigures(params, (response) => {
                this.data = response.data
                this.ebitda = this.data.economy.ebitda
                this.customerHours.now = response.data.timeloggings.avg_percent
                this.customerHours.max = 100 - response.data.timeloggings.avg_percent
                this.loading = false
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        }
    },
    computed: {
        customerHoursTotal () {
            if (this.data) {
                return this.data.coverage.total * (this.customerHours.value / this.customerHours.now)
            }
            return 0
        },
        projectRevenueTotal () {
            if (this.data) {
                return this.data.revenue.invoices_total * (this.projectRevenue.value / 100)
            }
            return 0
        },
        materialsUsageTotal () {
            if (this.data) {
                return this.data.materials.total * (this.materialsUsage.value / 100)
            }
            return 0
        },
        projects () {
            if (this.data && this.coveragePercent.value !== 0) {
                let projects = this.data.coverage.projects
                let responseProjects = []
                projects.forEach((project) => {
                    if (project.coverage_percent && project.coverage_percent < this.coveragePercent.value && project.coverage_percent > 0 && project.invoices_total > 0) {
                        responseProjects.push(project)
                    }
                })
                return responseProjects
            }
        },
        coveragePercentTotal () {
            if (this.data && this.coveragePercent.value !== 0) {
                let projects = this.projects
                let count = 0
                projects.forEach((project) => {
                    if (project.coverage_percent && project.coverage_percent < this.coveragePercent.value && project.coverage_percent > 0 && project.invoices_total > 0) {
                        count += ((this.coveragePercent.value - project.coverage_percent) / 100) * project.invoices_total
                    }
                })
                return count
            }
            return 0
        },
        totalPotential () {
            return this.ebitda + this.customerHoursTotal + this.projectRevenueTotal + this.materialsUsageTotal + this.coveragePercentTotal
        },
        globalParams () {
            let startDate = this.$store.getters.getStartDate
            let endDate = this.$store.getters.getEndDate
            let department = this.$store.getters.getCurrentDepartment.uuid
            return startDate + endDate + department
        }
    },
    watch: {
        globalParams: function () {
            this.getData()
        }
    }
}
</script>



// WEBPACK FOOTER //
// potential.vue?ec6a5a7e